import { useEffect, useState, useRef } from "react";
import { verify } from "../../apis/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import Auth from "./auth";
function Verify() {
  const [verifying, setVerifying] = useState({
    verifying: true,
    verified: false,
    status: null,
  });
  const hasRun = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  useEffect(() => {
    if (!token) {
      return navigate("/");
    }
    if (hasRun.current) return;
    verifyEmail();
    hasRun.current = true;
  }, []);
  const verifyEmail = async () => {
    const { data, error, status } = await verify(token);
    if (error) {
      return setVerifying((prevState) => {
        return {
          verifying: false,
          verified: false,
          status: status,
        };
      });
    }

    setVerifying((prevState) => {
      return {
        verifying: false,
        verified: true,
        status: null,
      };
    });
  };
  return (
    <div className="flex items-center justify-center h-full">
      {/* <h1>VERIFY PAGE D</h1> */}
      {verifying.verifying && (
        <span className="flex justify-center items-end text-center">
          verifying <span class="loading loading-dots loading-xs"></span>
        </span>
      )}
      {!verifying.verifying && verifying.verified && (
        <h1>
          Email has been verified.{" "}
          <a href="/join/signin" className="link text-custom-blue">
            signin
          </a>
        </h1>
      )}
      {!verifying.verifying &&
        !verifying.verified &&
        verifying.status !== 409 && (
          <div className="flex flex-col justify-center items-center gap-5">
            <h1 className="text-2xl font-bold">Your link didn't work</h1>
            <p>Try clicking the link in your email again.</p>
            <p>
              To generate a new email, please{" "}
              <a href="/join/signup" className="link text-custom-blue">
                signup
              </a>{" "}
              again
            </p>
          </div>
        )}{" "}
      {!verifying.verifying &&
        !verifying.verified &&
        verifying.status === 409 && (
          <h1>
            Email has already been verified.{" "}
            <a href="/join/signin" className="link text-custom-blue">
              signin
            </a>
          </h1>
        )}
    </div>
  );
}

export default Verify;
